/*
 * Copyright 2024 ByOmakase, LLC (https://byomakase.org)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// @ts-ignore
import {Config, Node} from 'yoga-layout';

export class YogaUtil {
  public static free(...nodes: Node | Config | undefined) {
    nodes.forEach((node: Node) => {
      if (node) {
        try {
          node.free();
        } catch (e) {
          // console.error(e);
        }
      }
    });
  }
}

export function yogaLiberator(...nodes: (Node | Config | undefined)[]) {
  YogaUtil.free(...nodes);
}
